import React from 'react'
import './task-card.css'

const TaskCard = (props) => {

    const populateModal = (e, type) => {
        if(e.target.id === 'task-checkmark') {
            props.deleteTask(props.todo)
        } 
        else if (e.target.id === 'task-card' || e.target.id === props.todo.todoId){
            if(type === 'todo') {
                props.openModal(props.todo)
            } else {
                if(typeof props.toggleItsAWorkflow === 'function') {
                    props.toggleItsAWorkflow()
                }
                props.openModal(props.todo)
            }
        }
    }

    const sortSubtaskDueDates = () => {
        let myList = []
        for(let i = 0; i < props.todo.todoSubtasks.length; i++) {
            let theDate = new Date(props.todo.todoSubtasks[i].subtaskDueDate)
            myList.push(theDate)
        }
        myList.sort = (a,b) => {
            if(a > b) {
                return 1
            } else {
                return -1
            }
        }
        return myList[0]
    }

    let dateToDisplay = new Date(props.todo.todoDueDate)
    if(sortSubtaskDueDates()) {
        dateToDisplay = sortSubtaskDueDates()
    }
    let theColor = ''
    let theAnimation = ''
    if(props.todo.whichList === 'workflows') {
        if(new Date(props.todo.todoDueDate) < new Date().setHours(1,0,0,0)) {
            theColor = "rgba(253, 186, 186, 0.6)"
            theAnimation = "flash 1s 3"
        } else if (new Date(props.todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(props.todo.todoDueDate) > new Date().setHours(1,0,0,0)) {
            theColor = "rgba(253, 248, 186, 0.6)"
        } else {}
    }
    if(props.todo.todoAlarm === true) {
        if(props.whichList === 'todos') {
            return (
                <div className="task-card" id="task-card" style={{backgroundColor: theColor, animation: theAnimation}} onClick={(e) => populateModal(e, 'todo')}>
                    <div className="task-checkmark" id={"task-checkmark-" + props.todo.todoId} onClick={() => props.deleteTask(props.todo, props.whichList)}></div>
                    <h4 className="task-card-name" id={props.todo.todoId}>{props.todo.todoName.length > 35 ? props.todo.todoName.substring(0, 34) + '...' : props.todo.todoName}</h4>
                    {props.todo.whichSchool && <h5 className="task-card-school">{props.todo.whichSchool.toUpperCase()}</h5>}
                    <h5 className="tasks-left">{props.todo.todoSubtasks.length}</h5>
                </div>
            )
        } else {
            return (
                <div className="task-card" id="task-card" style={{backgroundColor: theColor, animation: theAnimation}} onClick={(e) => populateModal(e, 'work')}>
                    <h4 className="task-card-name" id={props.todo.todoId}>{props.todo.todoName.length > 35 ? props.todo.todoName.substring(0, 34) + '...' : props.todo.todoName}</h4>
                    {props.todo.whichSchool && <h5 className="task-card-school">{props.todo.whichSchool.toUpperCase()}</h5>}
                    <h5 className="tasks-left">{props.todo.todoSubtasks.length}</h5>
                </div>
            ) 
        }
    } else {
        if(props.whichList === 'todos') {
            return (
                <div className="task-card" id="task-card" style={{backgroundColor: theColor, animation: theAnimation}} onClick={(e) => populateModal(e, 'todo')}>
                    <div className="task-checkmark" id={"task-checkmark-" + props.todo.todoId} onClick={() => props.deleteTask(props.todo, props.whichList)}></div>
                    <h4 className="task-card-name" id={props.todo.todoId}>{props.todo.todoName.length > 35 ? props.todo.todoName.substring(0, 34) + '...' : props.todo.todoName}</h4>
                    {props.todo.todoSubtasks.length > 0 && <h5 className="tasks-left">{props.todo.todoSubtasks.length}</h5>}
                </div>
            )
        } else {
            return (
                <div className="task-card" id="task-card" style={{backgroundColor: theColor, animation: theAnimation}} onClick={(e) => populateModal(e, 'work')}>
                    <h4 className="task-card-name" id={props.todo.todoId}>{props.todo.todoName.length > 35 ? props.todo.todoName.substring(0, 34) + '...' : props.todo.todoName}</h4>
                    <div className="task-trashcan" id={"task-checkmark-" + props.todo.todoId} onClick={() => props.deleteWorkflow(props.todo)}></div>
                    {props.todo.whichSchool && <h5 className="task-card-school">{props.todo.whichSchool.toUpperCase()}</h5>}
                    <h5 className="tasks-left">{props.todo.todoSubtasks.length}</h5>
                </div>
            ) 
        }
    }
}

export default TaskCard